import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-remember-password',
  templateUrl: './remember-password.component.html',
  styleUrls: ['./remember-password.component.scss']
})
export class RememberPasswordComponent implements OnInit {

  form;
  token;
  checkNewPassword;
  checkNewPasswordCheck;
  message = '';
  emailData = new FormGroup({
    email: new FormControl('')
  });
  setNewPassword = new FormGroup({
    newPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
    newPasswordCheck: new FormControl('', [Validators.required, Validators.minLength(8)]),
    token: new FormControl('')
  });


  constructor(private router: Router,
              private route: ActivatedRoute,
              private http: HttpClient
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        this.form = false;
        this.token = params.token;
      } else {
        this.form = true;
      }
    });
  }

  // On submit click, reset form fields
  onSubmit(): void {
    console.log(this.emailData.value);
    this.http.post('public/user/sendPasswordToken', this.emailData.value).subscribe(res => {
      console.log(res);
     /* this.alertService.success(res.message, 'email inviata', {
        autoClose: true,
        keepAfterRouteChange: false
      });*/

    }, err => {
      console.log(err);
      /*this.alertService.error(err.message, 'Qualcosa non va', {
        autoClose: true,
        keepAfterRouteChange: false
      });*/
    });
    this.emailData.reset();
  }

  onSubmitPsw(): void {
    this.checkNewPassword = this.setNewPassword.value.newPassword;
    this.checkNewPasswordCheck = this.setNewPassword.value.newPasswordCheck;
    if (this.checkNewPassword !== this.checkNewPasswordCheck) {

    } else {
      this.setNewPassword.patchValue({token: this.token});
      console.log(this.setNewPassword.value);

      this.http.post('public/user/setNewPassword', this.setNewPassword.value).subscribe(res => {
       /* this.alertService.success(res.message, 'Password aggiornata', {
          autoClose: true,
          keepAfterRouteChange: false
        });*/
        setTimeout(() => {
          this.router.navigate(['/auth/login']);
        }, 3000);
      }, err => {
        console.log(err);
       /* this.alertService.error(err.error.msg, 'Qualcosa non va..', {
          autoClose: true,
          keepAfterRouteChange: false
        });*/
      });

    }
  }


}
